import { Component, OnInit } from '@angular/core';
import { AlertController, MenuController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../services/translate-config.service';
import { Router } from '@angular/router';
import { AuthServicesService } from '../auth-services.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.page.html',
  styleUrls: ['./language.page.scss'],
})
export class LanguagePage implements OnInit {
  language: string = "English";
  default: string = "en";
  constructor(private alert: AlertController,
    private translateConfigService: TranslateConfigService,
    private translate: TranslateService,
    private router: Router,
    private menuCtrl: MenuController,
    private auth: AuthServicesService
  ) { }

  ngOnInit() {
    this.menuCtrl.enable(false)
    if (this.auth.isAuthenticate()) {
      if (localStorage.getItem('role_id') == '1') {

        this.router.navigate(['home/tabs/poultry-home']);
      }
      else if (localStorage.getItem('role_id') == '4' || localStorage.getItem('role_id') == '5' || localStorage.getItem('role_id') == '6' || localStorage.getItem('role_id') == '7' || localStorage.getItem('role_id') == '14' || localStorage.getItem('role_id') == '19') {
        this.router.navigate(['/dealer']);

      }
      else if (localStorage.getItem('role_id') == '2') {
        this.router.navigate(['/trader/tabs/orders']);

      }
      else if (localStorage.getItem('role_id') == '10') {
        this.router.navigate(['/chicken-center-home/tabs/chicken-home']);

      }
      else if (localStorage.getItem('role_id') == '8') {
        this.router.navigateByUrl('/trader-van-home');

      } else if (localStorage.getItem('role_id') == '9') {
        this.router.navigateByUrl('/layerfarmer/tabs/home');

      } else if (localStorage.getItem('role_id') == '18') {
        // this.router.navigateByUrl('/retailer/tabs/home');
        this.router.navigate(['/home/tabs/poultry-home'],{replaceUrl:true});
      }
      else if (localStorage.getItem('role_id') == '3') {
        this.router.navigateByUrl('/supervisor');

      } else if (localStorage.getItem('role_id') == '15') {
        // this.router.navigateByUrl('/wholeseller');
        this.router.navigate(['/home/tabs/poultry-home'],{replaceUrl:true});

      } else if (localStorage.getItem('role_id') == '11') {
        this.router.navigateByUrl('/layersupervisor');

      } else if (localStorage.getItem('role_id') == '17') {
        // this.router.navigateByUrl('/layer-seller/tabs/seller-home');
        this.router.navigate(['/home/tabs/poultry-home'],{replaceUrl:true});

      }
      else {
        this.router.navigate(['/home']);
        // this.loadingController.dismiss().then(a => console.log('dismisssed'));
      }
    } 
  }
  async langTranslate() {
    const alert = await this.alert.create({
      inputs: [
        {
          label: 'English',
          value: 'English',
          type: 'radio',
          checked: this.language == 'English',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        },
        {
          label: 'हिन्दी',
          value: this.translate.instant("languages.hindi"),
          type: 'radio',
          checked: this.language == 'हिन्दी',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        },
        {
          label: 'తెలుగు',
          value: this.translate.instant("languages.telugu"),
          type: 'radio',
          checked: this.language == 'తెలుగు',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        },
        {
          label: 'தமிழ்',
          value: this.translate.instant("languages.tamil"),
          type: 'radio',
          checked: this.language == 'தமிழ்',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        },
        {
          label: this.translate.instant("languages.kannada"),
          type: 'radio',
          value: 'ಕನ್ನಡ',
          checked: this.language == 'ಕನ್ನಡ',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        },
        {
          label: this.translate.instant("languages.malayalam"),
          type: 'radio',
          value: 'ಮಲಯಾಳಂ',
          checked: this.language == 'ಮಲಯಾಳಂ',
          handler: (res) => {
            this.changeLanguage(res.value)
          }
        }
      ],
      header: this.translate.instant("languages.selectLanguage"),
      cssClass: 'withoutButtons',
    });
    await alert.present();
  }
  changeLanguage(val) {
    this.alert.dismiss();
    this.language = val;
    this.default = (val == "తెలుగు") ? "te" : (val == "हिन्दी") ? "hi" : (val == "தமிழ்") ? "ta" : (val == "ಕನ್ನಡ") ? 'ka' : (val == "ಮಲಯಾಳಂ") ? 'ma' : "en";
    this.translateConfigService.setLanguage(this.default);
  
  }

  next() {
    localStorage.setItem("lang", this.language);
    localStorage.setItem('lngCode', this.default);
    this.router.navigateByUrl('/user-authentication',{ replaceUrl: true })
  }
}
